import React from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import './App.css';
import Test from './components/test';

// Custom UI overrides
const components = {
  SignIn: {
    Header() {
      return (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <h2 style={{ marginBottom: 10 }}>PrimU Admin Login</h2>
          <img
            src="https://primu-test-bucket.s3.eu-west-1.amazonaws.com/images/primU_logo.png"
            alt="Prim-U Logo"
            style={{ maxWidth: '200px', height: 'auto' }}
          />
        </div>
      );
    },
  },
};

function App({ signOut, user }) {
  return (
    <div className="App">
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 20px',
          background: '#f9f4fe',
          borderBottom: '1px solid #ddd',
        }}
      >
        <h3>Welcome, {user?.attributes?.email}</h3>
        <button onClick={signOut} style={{ padding: '6px 12px' }}>
          Logout
        </button>
      </header>
      <main>
        <Test />
      </main>
    </div>
  );
}

export default withAuthenticator(App, {
  hideSignUp: true,
  components,
});
